import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkZoneListParamsRawI,
	type LWApiPublicNetworkZoneListResultRawI,
} from '@liquidweb-dev/club-sauce/public/network/zone.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_ZONE_LIST_QUERY_KEY = '/network/zone/list';

const useNetworkZoneList = <TData = LWApiPublicNetworkZoneListResultRawI>(
	params: LWApiPublicNetworkZoneListParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicNetworkZoneListResultRawI,
		ApiErrorI,
		TData
	>,
) =>
	useQuery({
		queryKey: [NETWORK_ZONE_LIST_QUERY_KEY, params],
		queryFn: () => api.network.zone.apiRaw.list(params),
		...options,
	});

export default useNetworkZoneList;
